import { ssrApi } from 'api/ssr';
import { SocialProviders } from 'components/social-providers';
import { MainPage, Props } from 'components/template/home';
import { ParsedUrlQuery } from 'querystring';
import { Home } from 'lib/api/home';

export default function Main({
  news,
  allSlots,
  allProviders,
  allCasinos,
  latestSlotReviews,
  lastSlotReviewsCount,
  allSlotsCount,
  allCasinosCount,
  allProvidersCount,
}: Props) {
  return (
    <SocialProviders>
      <MainPage
        news={news}
        allSlots={allSlots}
        allProviders={allProviders}
        allCasinos={allCasinos}
        latestSlotReviews={latestSlotReviews}
        lastSlotReviewsCount={lastSlotReviewsCount}
        allSlotsCount={allSlotsCount}
        allProvidersCount={allProvidersCount}
        allCasinosCount={allCasinosCount}
      />
    </SocialProviders>
  );
}

export async function getServerSideProps({
  res,
  query,
}: {
  res: any;
  query: ParsedUrlQuery;
}) {
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59'
  );

  const { reg } = query;

  const region = reg ? reg.toString() : null;

  const homeData: Home = await ssrApi.home.get(region);

  const {
    news,
    allSlots,
    allProviders,
    allCasinos,
    latestSlotReviews,
    lastSlotReviewsCount,
    allSlotsCount,
    allCasinosCount,
    allProvidersCount,
  } = homeData;

  return {
    props: {
      news,
      allSlots,
      allProviders,
      allCasinos,
      latestSlotReviews,
      lastSlotReviewsCount,
      allSlotsCount,
      allCasinosCount,
      allProvidersCount,
    },
  };
}
